var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePhone2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 16,
      height: 16,
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 3.33333C1.33333 2.22876 2.22876 1.33333 3.33333 1.33333H4.83C5.29 1.33333 5.69 1.646 5.80333 2.09133L6.51 4.92C6.60933 5.31733 6.46066 5.736 6.132 5.98L5.03 6.80666C5.90066 8.55 7.45 10.0993 9.19333 10.97L10.02 9.868C10.264 9.53933 10.6827 9.39066 11.08 9.49L13.9087 10.1967C14.354 10.31 14.6667 10.71 14.6667 11.17V12.6667C14.6667 13.7712 13.7712 14.6667 12.6667 14.6667H12C6.10933 14.6667 1.33333 9.89066 1.33333 4V3.33333Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePhone2);
export default __webpack_public_path__ + "static/media/white-phone-2.55026c3f42431306e2c9a464245f0fa3.svg";
export { ForwardRef as ReactComponent };